/* ============================================================================
FILE: po-gears-quiz-texts-fr-en-es-20260321.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoGearsQuizTextsFR_EN_ES_20260321
ROOT: .po-gears-quiz-section[data-po-gears-quiz="engrenages_quiz"]

RÔLE:
- injecte le contenu FR/EN/ES du quiz des Engrenages
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- conserve la logique score / réponses / compteur
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_GEARS_QUIZ_TEXTS_20260321__) return;
  window.__PO_GEARS_QUIZ_TEXTS_20260321__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-gears-quiz-section[data-po-gears-quiz="engrenages_quiz"]';
  var COUNTER_KEY = "poso_counts";

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);
    uniqPush(out, t.replace(/’/g, "'"));
    uniqPush(out, t.replace(/'/g, "’"));
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"));
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"));
    return out;
  }

  function getSimplifiedLexiqueFRList() {
    var merged = [];
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        for (var i = 0; i < window.PO_LEXICON_META.lexique_simplifie_fr.length; i++) {
          uniqPush(merged, window.PO_LEXICON_META.lexique_simplifie_fr[i]);
        }
      }
    } catch (e) {}

    [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Axis",
      "Organon posœnnoïal",
      "Katûvýs",
      "Katûvýsissence",
      "RéZonans",
      "Péroptissimisme",
      "Aliœvolution",
      "Illusion",
      "Addition synchrêtique",
      "Superposition de perspectives",
      "Instantané multiple",
      "Sujet pluriel",
      "Engrenages posœnnoïaux",
      "Posœnnoïaque",
      "Posœnnoïque",
      "Posœnnomia",
      "Posœnnoïamie",
      "Temporalité élargie",
      "Temporalité éclatée",
      "Modalités opératives"
    ].forEach(function (term) {
      uniqPush(merged, term);
    });

    return merged;
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    return new RegExp(parts.join("|"), "g");
  }

  function protectLexiconInHTML(html) {
    var src = clampStr(html);
    if (!src) return "";
    var rx = buildProtectMatcher();
    return src.replace(rx, function (m) {
      return '<span translate="no" class="po-lex-protect">' + m + "</span>";
    });
  }

  function setText(el, txt) {
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = data && data.alt ? data.alt : "";
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
    } else {
      el.setAttribute("hidden", "");
    }
  }

  function loadCounter() {
    try {
      return JSON.parse(localStorage.getItem(COUNTER_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function saveCounter(data) {
    try {
      localStorage.setItem(COUNTER_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function bump(path) {
    if (!path) return;
    var data = loadCounter();
    var keys = String(path).split(".");
    var ref = data;

    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (i === keys.length - 1) {
        ref[k] = (ref[k] || 0) + 1;
      } else {
        ref[k] = ref[k] || {};
        ref = ref[k];
      }
    }

    saveCounter(data);

    try {
      window.dispatchEvent(new StorageEvent("storage", {
        key: COUNTER_KEY,
        newValue: JSON.stringify(data)
      }));
    } catch (e) {}
  }

  var UI = {
    fr: {
      langbar_aria: "Langue",
      sections_aria: "Engrenages du quiz",
      submit_cta: "Afficher le score",
      warning_incomplete: "Merci de répondre à toutes les questions avant d’afficher le score.",
      toggle_answers_show: "👉 Voir les bonnes réponses",
      toggle_answers_hide: "👉 Masquer les bonnes réponses",
      cta_translate: "Proposer une traduction du concept",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennoiaux_Engrenage_2_b76657c5-7262-47c6-bff5-caf63af686e6.png?v=1770249499",
        alt: "Idéogramme des Engrenages posœnnoïaux"
      },
      tabs: {
        general: "Engrenages posœnnoïaux",
        posoennoiaque: "Posœnnoïaque",
        posoennoique: "Posœnnoïque"
      },
      sections: {
        general: {
          title: "Quiz – Engrenages posœnnoïaux",
          kicker: "Respiration interne de l’Organon posœnnoïal entre accumulation et épure."
        },
        posoennoiaque: {
          title: "Quiz – Engrenage Posœnnoïaque",
          kicker: "Phase d’accumulation, d’amplification et d’ouverture sélective."
        },
        posoennoique: {
          title: "Quiz – Engrenage Posœnnoïque",
          kicker: "Phase d’épure, de condensation, de structuration et de quintessence."
        }
      },
      scoreText: function (score, total) {
        return "✨ Vous avez obtenu <strong>" + score + "/" + total + "</strong> bonnes réponses.";
      }
    },

    en: {
      langbar_aria: "Language",
      sections_aria: "Quiz gears",
      submit_cta: "Show the score",
      warning_incomplete: "Please answer every question before showing the score.",
      toggle_answers_show: "👉 View the correct answers",
      toggle_answers_hide: "👉 Hide the correct answers",
      cta_translate: "Proposer une traduction du concept",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennoiaux_Engrenage_2_b76657c5-7262-47c6-bff5-caf63af686e6.png?v=1770249499",
        alt: "Ideogram of the Posœnnoïal Gears"
      },
      tabs: {
        general: "Engrenages posœnnoïaux",
        posoennoiaque: "Posœnnoïaque",
        posoennoique: "Posœnnoïque"
      },
      sections: {
        general: {
          title: "Quiz – Posœnnoïal Gears",
          kicker: "Inner respiration of the Organon posœnnoïal between accumulation and distillation."
        },
        posoennoiaque: {
          title: "Quiz – Posœnnoïaque Gear",
          kicker: "Phase of accumulation, amplification, and selective opening."
        },
        posoennoique: {
          title: "Quiz – Posœnnoïque Gear",
          kicker: "Phase of distillation, condensation, structuring, and quintessence."
        }
      },
      scoreText: function (score, total) {
        return "✨ You scored <strong>" + score + "/" + total + "</strong> correct answers.";
      }
    },

    es: {
      langbar_aria: "Idioma",
      sections_aria: "Engranajes del quiz",
      submit_cta: "Mostrar la puntuación",
      warning_incomplete: "Gracias por responder a todas las preguntas antes de mostrar la puntuación.",
      toggle_answers_show: "👉 Ver las respuestas correctas",
      toggle_answers_hide: "👉 Ocultar las respuestas correctas",
      cta_translate: "Proposer une traduction du concept",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennoiaux_Engrenage_2_b76657c5-7262-47c6-bff5-caf63af686e6.png?v=1770249499",
        alt: "Ideograma de los Engranajes posœnnoïales"
      },
      tabs: {
        general: "Engrenages posœnnoïaux",
        posoennoiaque: "Posœnnoïaque",
        posoennoique: "Posœnnoïque"
      },
      sections: {
        general: {
          title: "Quiz – Engranajes posœnnoïales",
          kicker: "Respiración interna del Organon posœnnoïal entre acumulación y depuración."
        },
        posoennoiaque: {
          title: "Quiz – Engranaje Posœnnoïaque",
          kicker: "Fase de acumulación, amplificación y apertura selectiva."
        },
        posoennoique: {
          title: "Quiz – Engranaje Posœnnoïque",
          kicker: "Fase de depuración, condensación, estructuración y quintaesencia."
        }
      },
      scoreText: function (score, total) {
        return "✨ Ha obtenido <strong>" + score + "/" + total + "</strong> respuestas correctas.";
      }
    }
  };

  var BANK = {
    general: [
      {
        ans: "b",
        q: {
          fr: "Les Engrenages posœnnoïaux instaurent avant tout :",
          en: "The Engrenages posœnnoïaux primarily establish:",
          es: "Los Engrenages posœnnoïaux instauran ante todo:"
        },
        options: {
          a: { fr: "Une immobilité doctrinale", en: "A doctrinal immobility", es: "Una inmovilidad doctrinal" },
          b: { fr: "Une oscillation permanente entre accumulation et épure", en: "A permanent oscillation between accumulation and distillation", es: "Una oscilación permanente entre acumulación y depuración" },
          c: { fr: "Une clôture des Outils", en: "A closure of the Outils", es: "Un cierre de las Outils" },
          d: { fr: "Une hiérarchie des Piliers", en: "A hierarchy of the Piliers", es: "Una jerarquía de los Piliers" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Dans l’Organon posœnnoïal, les Engrenages sont surtout :",
          en: "Within the Organon posœnnoïal, the Engrenages are above all:",
          es: "En el Organon posœnnoïal, los Engrenages son sobre todo:"
        },
        options: {
          a: { fr: "Des accessoires secondaires", en: "Secondary accessories", es: "Accesorios secundarios" },
          b: { fr: "Des agents moteurs essentiels", en: "Essential driving agents", es: "Agentes motores esenciales" },
          c: { fr: "Des éléments décoratifs", en: "Decorative elements", es: "Elementos decorativos" },
          d: { fr: "Des pratiques rituelles", en: "Ritual practices", es: "Prácticas rituales" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Le couple Posœnnoïaque / Posœnnoïque agit sur :",
          en: "The pair Posœnnoïaque / Posœnnoïque acts upon:",
          es: "La pareja Posœnnoïaque / Posœnnoïque actúa sobre:"
        },
        options: {
          a: { fr: "Les Outils, pour les mettre en mouvement", en: "The Outils, in order to set them in motion", es: "Las Outils, para ponerlas en movimiento" },
          b: { fr: "Le seul langage", en: "Language alone", es: "Solo el lenguaje" },
          c: { fr: "Les seuls nombres-guides", en: "The guide-numbers alone", es: "Solo los números-guía" },
          d: { fr: "Les seules Pratiques", en: "The Practices alone", es: "Solo las Prácticas" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Leur fonction globale est de maintenir :",
          en: "Their overall function is to maintain:",
          es: "Su función global es mantener:"
        },
        options: {
          a: { fr: "Une rigidité stable", en: "A stable rigidity", es: "Una rigidez estable" },
          b: { fr: "Une cohérence mouvante sans effondrement", en: "A moving coherence without collapse", es: "Una coherencia móvil sin colapso" },
          c: { fr: "Une expansion sans mesure", en: "An expansion without measure", es: "Una expansión sin medida" },
          d: { fr: "Une simplification intégrale", en: "An integral simplification", es: "Una simplificación integral" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Le rythme des Engrenages évoque surtout :",
          en: "The rhythm of the Engrenages chiefly evokes:",
          es: "El ritmo de los Engrenages evoca sobre todo:"
        },
        options: {
          a: { fr: "Une ligne fixe", en: "A fixed line", es: "Una línea fija" },
          b: { fr: "Une respiration interne du système", en: "An inner respiration of the system", es: "Una respiración interna del sistema" },
          c: { fr: "Une coupure du sens", en: "A severing of meaning", es: "Una ruptura del sentido" },
          d: { fr: "Un simple tri mécanique", en: "A simple mechanical sorting", es: "Una simple clasificación mecánica" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Les séquences fonctionnelles des Engrenages matérialisent :",
          en: "The functional sequences of the Engrenages materialize:",
          es: "Las secuencias funcionales de los Engrenages materializan:"
        },
        options: {
          a: { fr: "Une respiration méthodique du système", en: "A methodical respiration of the system", es: "Una respiración metódica del sistema" },
          b: { fr: "Une pure répétition", en: "A pure repetition", es: "Una pura repetición" },
          c: { fr: "Une absence de modulation", en: "An absence of modulation", es: "Una ausencia de modulación" },
          d: { fr: "Une dissociation des polarités", en: "A dissociation of polarities", es: "Una disociación de las polaridades" }
        }
      }
    ],

    posoennoiaque: [
      {
        ans: "b",
        q: {
          fr: "L’Engrenage Posœnnoïaque est principalement orienté vers :",
          en: "The Posœnnoïaque Gear is chiefly oriented toward:",
          es: "El Engranaje Posœnnoïaque está orientado principalmente hacia:"
        },
        options: {
          a: { fr: "La réduction à l’essentiel", en: "Reduction to the essential", es: "La reducción a lo esencial" },
          b: { fr: "L’accumulation, l’amplification et la complexification", en: "Accumulation, amplification, and complexification", es: "La acumulación, la amplificación y la complejización" },
          c: { fr: "Le silence du système", en: "The silence of the system", es: "El silencio del sistema" },
          d: { fr: "La fermeture des seuils", en: "The closing of thresholds", es: "El cierre de los umbrales" }
        }
      },
      {
        ans: "c",
        q: {
          fr: "Son nombre-guide est :",
          en: "Its guide-number is:",
          es: "Su número-guía es:"
        },
        options: {
          a: { fr: "22", en: "22", es: "22" },
          b: { fr: "28", en: "28", es: "28" },
          c: { fr: "26", en: "26", es: "26" },
          d: { fr: "84", en: "84", es: "84" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Dans sa séquence fonctionnelle, l’Engrenage Posœnnoïaque conduit vers :",
          en: "In its functional sequence, the Posœnnoïaque Gear leads toward:",
          es: "En su secuencia funcional, el Engranaje Posœnnoïaque conduce hacia:"
        },
        options: {
          a: { fr: "Accumulation → Amplification → Complexification → Stratification → Ouverture", en: "Accumulation → Amplification → Complexification → Stratification → Opening", es: "Acumulación → Amplificación → Complejización → Estratificación → Apertura" },
          b: { fr: "Épure → Condensation → Structuration → Quintessence → Stabilisation", en: "Distillation → Condensation → Structuring → Quintessence → Stabilization", es: "Depuración → Condensación → Estructuración → Quintaesencia → Estabilización" },
          c: { fr: "Silence → Fixation → Clôture", en: "Silence → Fixation → Closure", es: "Silencio → Fijación → Cierre" },
          d: { fr: "Dissolution → Oubli → Arrêt", en: "Dissolution → Forgetting → Stop", es: "Disolución → Olvido → Detención" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Le geste du Posœnnoïaque consiste à :",
          en: "The gesture of the Posœnnoïaque consists in:",
          es: "El gesto del Posœnnoïaque consiste en:"
        },
        options: {
          a: { fr: "Condamner l’altérité", en: "Condemn alterity", es: "Condenar la alteridad" },
          b: { fr: "Élargir le spectre des possibles par intégration", en: "Broaden the spectrum of possibilities through integration", es: "Ampliar el espectro de lo posible mediante integración" },
          c: { fr: "Neutraliser les apports", en: "Neutralize contributions", es: "Neutralizar los aportes" },
          d: { fr: "Supprimer les strates", en: "Suppress strata", es: "Suprimir los estratos" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Dans le corpus, l’Engrenage Posœnnoïaque correspond à une dynamique :",
          en: "In the corpus, the Posœnnoïaque Gear corresponds to a dynamic of:",
          es: "En el corpus, el Engranaje Posœnnoïaque corresponde a una dinámica de:"
        },
        options: {
          a: { fr: "Systole rigoureuse", en: "Rigorous systole", es: "Sístole rigurosa" },
          b: { fr: "Expansion consciente et sélective", en: "Conscious and selective expansion", es: "Expansión consciente y selectiva" },
          c: { fr: "Inertie formelle", en: "Formal inertia", es: "Inercia formal" },
          d: { fr: "Restriction continue", en: "Continuous restriction", es: "Restricción continua" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "L’Engrenage Posœnnoïaque nourrit les Outils en leur fournissant :",
          en: "The Posœnnoïaque Gear feeds the Outils by providing them with:",
          es: "El Engranaje Posœnnoïaque nutre las Outils proporcionándoles:"
        },
        options: {
          a: { fr: "Des matériaux à explorer, rassembler et démultiplier", en: "Materials to explore, gather, and multiply", es: "Materiales para explorar, reunir y multiplicar" },
          b: { fr: "Une clôture finale", en: "A final closure", es: "Un cierre final" },
          c: { fr: "Une réduction à un seul plan", en: "A reduction to a single plane", es: "Una reducción a un solo plano" },
          d: { fr: "Une neutralité sans tension", en: "A neutrality without tension", es: "Una neutralidad sin tensión" }
        }
      }
    ],

    posoennoique: [
      {
        ans: "b",
        q: {
          fr: "L’Engrenage Posœnnoïque est principalement orienté vers :",
          en: "The Posœnnoïque Gear is chiefly oriented toward:",
          es: "El Engranaje Posœnnoïque está orientado principalmente hacia:"
        },
        options: {
          a: { fr: "L’accumulation illimitée", en: "Unlimited accumulation", es: "La acumulación ilimitada" },
          b: { fr: "L’épure, la condensation et la structuration", en: "Distillation, condensation, and structuring", es: "La depuración, la condensación y la estructuración" },
          c: { fr: "La dispersion maximale", en: "Maximum dispersion", es: "La dispersión máxima" },
          d: { fr: "L’oubli méthodique", en: "Methodical forgetting", es: "El olvido metódico" }
        }
      },
      {
        ans: "c",
        q: {
          fr: "Son nombre-guide est :",
          en: "Its guide-number is:",
          es: "Su número-guía es:"
        },
        options: {
          a: { fr: "26", en: "26", es: "26" },
          b: { fr: "22", en: "22", es: "22" },
          c: { fr: "28", en: "28", es: "28" },
          d: { fr: "10", en: "10", es: "10" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "Dans sa séquence fonctionnelle, l’Engrenage Posœnnoïque conduit vers :",
          en: "In its functional sequence, the Posœnnoïque Gear leads toward:",
          es: "En su secuencia funcional, el Engranaje Posœnnoïque conduce hacia:"
        },
        options: {
          a: { fr: "Épure → Condensation → Structuration → Quintessence → Stabilisation", en: "Distillation → Condensation → Structuring → Quintessence → Stabilization", es: "Depuración → Condensación → Estructuración → Quintaesencia → Estabilización" },
          b: { fr: "Accumulation → Amplification → Complexification → Stratification → Ouverture", en: "Accumulation → Amplification → Complexification → Stratification → Opening", es: "Acumulación → Amplificación → Complejización → Estratificación → Apertura" },
          c: { fr: "Fragmentation → Rupture → Silence", en: "Fragmentation → Rupture → Silence", es: "Fragmentación → Ruptura → Silencio" },
          d: { fr: "Addition → Surenchère → Saturation", en: "Addition → Escalation → Saturation", es: "Adición → Escalada → Saturación" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Le geste du Posœnnoïque consiste à :",
          en: "The gesture of the Posœnnoïque consists in:",
          es: "El gesto del Posœnnoïque consiste en:"
        },
        options: {
          a: { fr: "Accroître sans fin les strates", en: "Endlessly increase strata", es: "Aumentar sin fin los estratos" },
          b: { fr: "Clarifier sans appauvrir", en: "Clarify without impoverishing", es: "Clarificar sin empobrecer" },
          c: { fr: "Figer les possibles", en: "Freeze possibilities", es: "Fijar las posibilidades" },
          d: { fr: "Remplacer les Outils", en: "Replace the Outils", es: "Reemplazar las Outils" }
        }
      },
      {
        ans: "b",
        q: {
          fr: "Dans le corpus, l’Engrenage Posœnnoïque correspond à une dynamique :",
          en: "In the corpus, the Posœnnoïque Gear corresponds to a dynamic of:",
          es: "En el corpus, el Engranaje Posœnnoïque corresponde a una dinámica de:"
        },
        options: {
          a: { fr: "Dilatation centrifuge", en: "Centrifugal dilation", es: "Dilatación centrífuga" },
          b: { fr: "Systole rigoureuse et quintessenciation", en: "Rigorous systole and quintessentiation", es: "Sístole rigurosa y quintaesenciación" },
          c: { fr: "Expansion marginale", en: "Marginal expansion", es: "Expansión marginal" },
          d: { fr: "Neutralisation totale", en: "Total neutralization", es: "Neutralización total" }
        }
      },
      {
        ans: "a",
        q: {
          fr: "L’Engrenage Posœnnoïque nourrit les Outils en leur fournissant :",
          en: "The Posœnnoïque Gear feeds the Outils by providing them with:",
          es: "El Engranaje Posœnnoïque nutre las Outils proporcionándoles:"
        },
        options: {
          a: { fr: "Des formulations synchrêtiques adaptées et résonantes", en: "Adapted and resonant synchrêtic formulations", es: "Formulaciones sincréticas adaptadas y resonantes" },
          b: { fr: "Une accumulation brute sans filtre", en: "A raw accumulation without filter", es: "Una acumulación bruta sin filtro" },
          c: { fr: "Une dispersion des noyaux symboliques", en: "A dispersion of symbolic cores", es: "Una dispersión de los núcleos simbólicos" },
          d: { fr: "Une réduction à l’inertie", en: "A reduction to inertia", es: "Una reducción a la inercia" }
        }
      }
    ]
  };

  function getUI(lang) {
    return UI[lang] || UI.fr;
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function applySectionTabs(root, lang, sectionKey) {
    var ui = getUI(lang);
    var nav = root.querySelector("[data-po-section-tabs]");
    if (nav) nav.setAttribute("aria-label", ui.sections_aria);

    var labels = root.querySelectorAll("[data-po-section-label]");
    for (var i = 0; i < labels.length; i++) {
      var key = labels[i].getAttribute("data-po-section-label");
      setText(labels[i], ui.tabs[key] || key);
    }

    var buttons = root.querySelectorAll("[data-gear]");
    for (var j = 0; j < buttons.length; j++) {
      var isActive = buttons[j].getAttribute("data-gear") === sectionKey;
      if (isActive) buttons[j].classList.add("active");
      else buttons[j].classList.remove("active");
    }
  }

  function clearWarn(root) {
    var list = root.querySelector("#questionsList-gears");
    if (list) {
      var warns = list.querySelectorAll(".warn");
      for (var i = 0; i < warns.length; i++) warns[i].classList.remove("warn");
    }
    var warn = root.querySelector("#gears-warning");
    if (warn) warn.classList.add("hidden");
  }

  function clearFeedback(root) {
    var result = root.querySelector("#resultat-gears");
    var answersBox = root.querySelector("#reponsesBox-gears");
    var answersList = root.querySelector("#reponsesList-gears");

    if (result) result.innerHTML = "";
    if (answersBox) answersBox.classList.add("hidden");
    if (answersList) {
      answersList.classList.add("hidden");
      answersList.innerHTML = "";
    }

    root.dataset.submitted = "0";
    clearWarn(root);
  }

  function collectSelections(root, sectionKey) {
    var out = {};
    var bank = BANK[sectionKey] || [];
    for (var i = 0; i < bank.length; i++) {
      var qid = "gq" + (i + 1);
      var checked = root.querySelector('input[name="' + qid + '"]:checked');
      if (checked) out[qid] = checked.value;
    }
    return out;
  }

  function firstUnanswered(root, total) {
    for (var i = 1; i <= total; i++) {
      var name = "gq" + i;
      if (!root.querySelector('input[name="' + name + '"]:checked')) return i;
    }
    return 0;
  }

  function applyFrame(root, lang, sectionKey) {
    var ui = getUI(lang);
    var sec = ui.sections[sectionKey] || ui.sections.general;

    setImg(root.querySelector('[data-po-slot="title_img"]'), ui.title_img);
    setText(root.querySelector('[data-po-slot="title"]'), sec.title);
    setText(root.querySelector('[data-po-slot="kicker"]'), sec.kicker);
    setText(root.querySelector('[data-po-slot="submit_cta"]'), ui.submit_cta);
    setText(root.querySelector('[data-po-slot="warning_incomplete"]'), ui.warning_incomplete);
    setText(root.querySelector('[data-po-slot="toggle_answers_show"]'), ui.toggle_answers_show);
    setText(root.querySelector('[data-po-slot="cta_translate"]'), ui.cta_translate);

    var langbar = root.querySelector("[data-po-langbar]");
    if (langbar) langbar.setAttribute("aria-label", ui.langbar_aria);

    applyLangbar(root, lang);
    applySectionTabs(root, lang, sectionKey);
  }

  function renderQuestions(root, sectionKey, lang, preservedSelections) {
    var list = root.querySelector("#questionsList-gears");
    if (!list) return;

    var bank = BANK[sectionKey] || [];
    list.innerHTML = "";

    for (var i = 0; i < bank.length; i++) {
      var item = bank[i];
      var qid = "gq" + (i + 1);
      var qText = item.q[lang] || item.q.fr;
      var li = document.createElement("li");

      var html = '<p>' + protectLexiconInHTML(qText) + "</p>";
      ["a", "b", "c", "d"].forEach(function (key) {
        var opt = item.options[key][lang] || item.options[key].fr;
        html += '<label><input type="radio" name="' + qid + '" value="' + key + '"> ' +
          protectLexiconInHTML(opt) + "</label>";
      });

      li.innerHTML = html;
      list.appendChild(li);

      if (preservedSelections && preservedSelections[qid]) {
        var radio = li.querySelector('input[value="' + preservedSelections[qid] + '"]');
        if (radio) radio.checked = true;
      }
    }
  }

  function renderSection(root, sectionKey, lang, preservedSelections) {
    var safeLang = normLang(lang) || "fr";
    var safeSection = BANK[sectionKey] ? sectionKey : "general";

    root.dataset.currentSection = safeSection;
    applyFrame(root, safeLang, safeSection);
    renderQuestions(root, safeSection, safeLang, preservedSelections || null);
    clearFeedback(root);
  }

  function validateSection(root) {
    var lang = getLang();
    var ui = getUI(lang);
    var sectionKey = root.dataset.currentSection || "general";
    var bank = BANK[sectionKey] || [];
    var total = bank.length;
    var missingIndex = firstUnanswered(root, total);

    clearWarn(root);

    if (missingIndex) {
      var list = root.querySelector("#questionsList-gears");
      var li = list && list.children[missingIndex - 1];
      var warn = root.querySelector("#gears-warning");

      if (li) {
        li.classList.add("warn");
        try {
          li.scrollIntoView({ behavior: "smooth", block: "center" });
        } catch (e) {}
      }

      if (warn) warn.classList.remove("hidden");
      return;
    }

    var score = 0;
    var bonnes = [];

    for (var i = 0; i < bank.length; i++) {
      var item = bank[i];
      var qid = "gq" + (i + 1);
      var checked = root.querySelector('input[name="' + qid + '"]:checked');

      if (checked && checked.value === item.ans) score++;

      var good = item.options[item.ans][lang] || item.options[item.ans].fr;
      bonnes.push("<li>" + protectLexiconInHTML(good) + "</li>");
    }

    var result = root.querySelector("#resultat-gears");
    var answersBox = root.querySelector("#reponsesBox-gears");
    var answersList = root.querySelector("#reponsesList-gears");
    var toggle = root.querySelector("#showGearsAnswers");

    if (result) result.innerHTML = ui.scoreText(score, total);
    if (answersBox) answersBox.classList.remove("hidden");
    if (answersList) {
      answersList.innerHTML = "<ol>" + bonnes.join("") + "</ol>";
      answersList.classList.add("hidden");
    }
    if (toggle) toggle.textContent = ui.toggle_answers_show;

    if (root.dataset.submitted !== "1") {
      bump("engrenages." + sectionKey);
      root.dataset.submitted = "1";
    }
  }

  function toggleAnswers(root) {
    var lang = getLang();
    var ui = getUI(lang);
    var answersBox = root.querySelector("#reponsesBox-gears");
    var answersList = root.querySelector("#reponsesList-gears");
    var toggle = root.querySelector("#showGearsAnswers");

    if (!answersBox || !answersList || !toggle) return;
    if (answersBox.classList.contains("hidden")) return;

    answersList.classList.toggle("hidden");
    toggle.textContent = answersList.classList.contains("hidden")
      ? ui.toggle_answers_show
      : ui.toggle_answers_hide;
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function bindActions(root) {
    if (!root || root.__poGearsQuizBound) return;
    root.__poGearsQuizBound = true;

    var langButtons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < langButtons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(langButtons[i]);
    }

    var sectionButtons = root.querySelectorAll("[data-gear]");
    for (var j = 0; j < sectionButtons.length; j++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          renderSection(root, btn.getAttribute("data-gear"), getLang(), null);
        });
      })(sectionButtons[j]);
    }

    var submit = root.querySelector("#gears-submit");
    if (submit) {
      submit.addEventListener("click", function () {
        validateSection(root);
      });
    }

    var toggle = root.querySelector("#showGearsAnswers");
    if (toggle) {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        toggleAnswers(root);
      });
    }

    var list = root.querySelector("#questionsList-gears");
    if (list) {
      list.addEventListener("change", function () {
        clearWarn(root);
      });
    }
  }

  function setLang(lang) {
    var safeLang = normLang(lang) || "fr";
    storeLang(safeLang);
    syncDocumentLang(safeLang);

    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var sectionKey = root.dataset.currentSection || "general";
      var preservedSelections = collectSelections(root, sectionKey);
      renderSection(root, sectionKey, safeLang, preservedSelections);
    }

    notifyLocaleChanged();
    return safeLang;
  }

  function initOne(root) {
    if (!root || root.__poGearsQuizInit) return;
    root.__poGearsQuizInit = true;

    lockTranslation(root);
    bindActions(root);

    var defaultSection = root.getAttribute("data-po-default-section") || "general";
    renderSection(root, defaultSection, getLang(), null);
  }

  function init() {
    syncDocumentLang(getLang());
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  window.PoGearsQuizTextsFR_EN_ES_20260321 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    renderSection: renderSection,
    protectLexiconInHTML: protectLexiconInHTML
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  window.PosoMini = window.PosoMini || {};
  window.PosoMini.bump = bump;
  window.PosoMini.loadKey = function () { return COUNTER_KEY; };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();